import { useNavigate } from "react-router-dom";
import { Download, LogOut, ShieldCheck, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fmtDate } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/Common";
import QuotaBanner from "@/components/QuotaBanner";
import EmailVerifyNotice from "@/components/EmailVerifyNotice";

export default function Profile() {
  const { user, logout, setUser } = useAuth();
  const navigate = useNavigate();
  const c = user.consents || {};

  const exportData = async () => {
    const { data } = await api.get("/me/export");
    const url = URL.createObjectURL(new Blob([JSON.stringify(data, null, 2)], { type: "application/json" }));
    const a = document.createElement("a");
    a.href = url;
    a.download = "medico-delle-piante-dati.json";
    a.click();
    URL.revokeObjectURL(url);
  };
  const del = async () => {
    if (!window.confirm("Eliminare definitivamente account, piante, foto e analisi?")) return;
    try {
      await api.delete("/me");
      setUser(false);
      navigate("/");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const out = async () => {
    await logout();
    navigate("/");
  };

  return (
    <div className="space-y-5 px-5 py-6" data-testid="profile-page">
      <div>
        <p className="eyebrow">Profilo</p>
        <h1 className="font-serif text-4xl font-semibold text-[#0D2517]" data-testid="profile-name">{user.name}</h1>
        <p className="text-sm text-[#5b6b60]">{user.email}{user.role === "professional" && " · Professionista"}</p>
      </div>
      <EmailVerifyNotice />
      <QuotaBanner />
      <Card testid="privacy-card">
        <div className="mb-2 flex items-center gap-2"><ShieldCheck size={17} className="text-[#B39257]" /><h3 className="font-serif text-xl font-semibold">Privacy e consensi</h3></div>
        <p className="text-sm">Conservazione foto e anamnesi: <strong>{c.storage?.granted ? "concesso" : "non concesso"}</strong>{c.storage?.at && ` (${fmtDate(c.storage.at)})`}</p>
        <p className="text-sm">Uso anonimo per migliorare il servizio: <strong>{c.improvement?.granted ? "concesso" : "non concesso"}</strong></p>
        <button onClick={() => navigate("/consenso", { state: { next: "/profilo" } })} className="btn-secondary mt-3 w-full !py-2.5" data-testid="edit-consent-button">Modifica consensi</button>
        <button onClick={() => navigate("/privacy")} className="mt-3 w-full text-center text-xs underline" data-testid="profile-privacy-link">Informativa privacy e servizi esterni</button>
        <button onClick={() => navigate("/termini")} className="mt-2 w-full text-center text-xs underline" data-testid="profile-terms-link">Termini di utilizzo</button>
      </Card>
      <button onClick={exportData} className="btn-secondary w-full bg-white" data-testid="export-data-button"><Download size={16} /> Esporta i miei dati</button>
      <button onClick={out} className="btn-primary w-full" data-testid="logout-button"><LogOut size={16} /> ESCI</button>
      <button onClick={del} className="flex w-full items-center justify-center gap-2 text-xs text-[#B91C1C] underline" data-testid="delete-account-button"><Trash2 size={13} /> Elimina account e dati</button>
    </div>
  );
}
